<script lang="ts" setup>
import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useBrowserIcon } from '@/composables/useBrowserIcon'
import {
    useDeviceActivityStore,
    type DeviceActivity,
    type Session
} from '@/stores/setting/DeviceActivity'
import ElDescriptionDeviceActivity from './components/ElDescription/ElDescriptionDeviceActivity.vue'

const deviceActivityStore = useDeviceActivityStore()
const { getSortedDeviceActivity } = storeToRefs(deviceActivityStore)

onMounted(async () => {
    await Promise.all([deviceActivityStore.getDeviceActivity()])
})

function handleSignOutClick(session: Session, device: DeviceActivity) {
    console.log(session)
    console.log(device)

    // TODO: Add confirmation popup

    deviceActivityStore.deleteSession(session.id)
}
</script>

<template>
    <el-card shadow="never">
        <template v-for="(device, deviceIndex) in getSortedDeviceActivity" :key="deviceIndex">
            <el-space style="width: 100%" direction="vertical" :size="16" fill>
                <template v-for="(session, sessionIndex) in device.sessions" :key="sessionIndex">
                    <div class="d-flex gap-3">
                        <ElDescriptionDeviceActivity
                            style="width: 90%"
                            :title="`${device.os} ${device.osVersion} / ${session.browser}`"
                            :ipAddress="session.ipAddress"
                            :lastAccess="session.lastAccess"
                            :clients="session.clients"
                            :started="session.started"
                            :expires="session.expires"
                            :current="session.current ?? false"
                            :browserIcon="useBrowserIcon(session.browser)"
                        />
                        <el-button
                            v-if="!session.current"
                            @click="handleSignOutClick(session, device)"
                            class="ms-auto"
                            type="danger"
                            plain
                        >
                            {{ $t('settings.signOut') }}
                        </el-button>
                    </div>
                    <el-divider v-if="sessionIndex < device.sessions.length - 1" />
                </template>
            </el-space>
        </template>
    </el-card>
</template>
